import type { Channel } from '../types';

/**
 * Return the canonical display name for a channel.
 */
export function channelDisplayName(channel: Pick<Channel, 'name'>): string {
  return channel.name;
}
